'use client'

import Image from 'next/image'
import { FC, memo } from 'react'

import Link from '@/components/Link'

const Logo: FC<{ logoClicked?: () => void }> = ({ logoClicked }) => {
    return (
        <Link href="/" onClick={logoClicked}>
            <Image width={104} height={32} alt={`Lune Logo`} src={'/images/logos/lune-logo.png'} />
        </Link>
    )
}

export default memo(Logo, (prev, next) => {
    return JSON.stringify(prev.logoClicked) === JSON.stringify(next.logoClicked)
})
